import React, { Component } from 'react'
import { Select, Input, Button, Icon, Checkbox, Alert } from 'loyal-react'
import '@loyal_template/mileage.css'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { actions } from '.'
import { Loading } from '../../Loading'
import ModalServices from '../ModalServices/ModalServices'

const REGULATION_TYPE_VENDOR = 'Vendor'
class Mileage extends Component {
  state = {
    supplierId: 0,
    showModal: false,
    imageBanner: null,
    formValid: true,
    formMessage: '',
    points: '',
    loyaltyNumber: '',
    convertAllPoints: false,
    acceptTerms: false,
    partnerName: '',
    disabledField: true,
    fidelityLabel: ''
  }

  componentDidMount () {
    const catalogId = process.env.REACT_APP_CATALOG_ID_ITAU
    let catalogArray = catalogId && catalogId.split(',')
    // Obtendo os parceiros de milhas ao carregar a página.
    this.props.getPartners()
    this.props.clearCalculator()
    let loyaltyNumber = (catalogArray && catalogArray.includes(process.env.REACT_APP_CATALOG_ID) && this.props.participant &&
      this.props.participant.cpf && this.props.participant.cpf.value) || ''

    this.setState({ loyaltyNumber })
  }
  selectPartnersOnChange = item => {
    // Verificando o supplier selecionado.
    if (item === null || item === undefined || item === '') {
      this.setState({ points: '', supplierId: 0 })
      this.props.clearCalculator()
      return
    }

    this.setState({
      supplierId: item.vendorId,
      formValid: true,
      partnerName: item.name,
      points: 0,
      loyaltyNumber: this.state.loyaltyNumber,
      disabledField: false,
      acceptTerms: false,
      convertAllPoints: false,
      imageBanner: item.logoUrl,
      fidelityLabel: item.fidelityLabel
    })
    this.props.clearCalculator()
  }

  inputPointsOnblur = event => {
    // Verificando se o supplierId foi selecionado.
    if (this.state.supplierId === 0 || this.state.supplierId === undefined) {
      this.setState({
        formValid: false,
        formMessage: 'Selecione um parceiro de milhas.'
      })
      return
    }
    this.setState({
      formValid: true,
      formMessage: '',
      convertAllPoints: false,
      points: event.target.value
    })
    this.props.pointsToMiles(this.state.supplierId, this.state.points)
  }

  checkboxAllPointsChange = event => {
    // Verificando se o supplierId foi selecionado.
    if (this.state.supplierId === 0 || this.state.supplierId === undefined) {
      this.setState({
        formValid: false,
        formMessage: 'Selecione um parceiro de milhas.'
      })
      return
    }

    let balance = Math.floor(this.props.partBalance, 0)
    this.setState({ convertAllPoints: !this.state.convertAllPoints })

    if (event.target.checked) {
      this.setState({ points: balance })
      this.props.pointsToMiles(this.state.supplierId, balance)
    }
  }

  handleFormatValue = value => {
    if (!isNaN(value)) {
      return `${parseFloat(value).toLocaleString('pt-br', {
        minimumFractionDigits: this.props.currencyConfiguration.decimalPlaces,
        maximumFractionDigits: this.props.currencyConfiguration.decimalPlaces
      })} ${this.state.partnerName}`
    }
    return ''
  }

  checkboxRegulationChange = event => {
    this.setState({ acceptTerms: event.target.checked })
  }

  showTerms = () => {
    // Verificando se o supplierId foi selecionado.
    if (this.state.supplierId === 0 || this.state.supplierId === undefined) {
      this.setState({
        formValid: false,
        formMessage: 'Selecione um parceiro de milhas.'
      })
      return
    }

    this.setState({ showModal: true })
  }

  acceptTerms = accept => {
    this.setState({ acceptTerms: accept })
  }

  closeAlert = () => {
    this.setState({ formValid: true, formMessage: '' })
    this.props.closeError()
  }

  inputPointsOnChange = ({ target: { value } }) => {
    if (value.length >= 7) return

    const onlyNumbers = value.match(/\d+/g)
    if (onlyNumbers) return this.setState({ points: onlyNumbers.join([]) })
    this.setState({ points: '' })
  }

  inputOnlyNumbers = ({ target: { value } }) => {
    const onlyNumbers = value.match(/\d+/g)
    if (onlyNumbers) {
      return this.setState({ loyaltyNumber: onlyNumbers.join([]) })
    }
    this.setState({ loyaltyNumber: '' })
  }

  redeem = () => {
    // Verificando se o supplierId foi selecionado.
    if (this.state.supplierId === 0 || this.state.supplierId === undefined) {
      this.setState({
        formValid: false,
        formMessage: 'Selecione um parceiro de milhas.'
      })
      return
    }

    if (
      this.state.points === 0 ||
      this.state.points === undefined ||
      this.state.points === ''
    ) {
      this.setState({
        formMessage: `Insira a quantidade de ${this.props.currencyConfiguration.pointsName}`,
        formValid: false
      })
      return
    }

    this.props.mileageRedemption(this.getOrderRequest(), this.state.supplierId)
  }

  getOrderRequest = () => ({
    totalMiles: this.state.points,
    totalPoints: this.props.calculator.miles,
    loyaltyNumber: this.state.loyaltyNumber,
    cpf: this.props.participant.cpf.value,
    participantName: this.props.participant.name.value,
    catalogId: this.props.participant.catalogId,
    offline: false,
    orderItems: [
      {
        quantity: 1,
        points: this.props.calculator.miles,
        miles: this.state.points,
        totalPoints: this.props.calculator.miles,
        packageName: this.handleFormatValue(this.props.calculator.miles)
      }
    ],
    orderTypeId: 1
  })
  render () {
    const formValid = this.state.formValid && !this.props.errorRedemption
    const errorMessage = this.state.formMessage || (this.props.errorRedemption && this.props.errorRedemption.description ? this.props.errorRedemption.description : '')
    const readyForRedemption =
      formValid &&
      Number(this.state.points) > 0 &&
      this.state.acceptTerms &&
      this.state.loyaltyNumber

    return (
      <div className='container-mileage container-fluid bg-ui-5 pb-2'>
        <div className='container pb-2'>
          {formValid === true ? (
            ''
          ) : (
            <Alert
              isError
              title={this.props.errorRedemption.title ? this.props.errorRedemption.title : 'Não foi possível concluir a sua transferência.'}
              description={errorMessage}
              onClose={this.closeAlert}
            />
          )}
        </div>
        <div className='container'>
          <div className='mileage bg-ui-4 row mx-0 border border-color-ui-4'>
            <div
              className='mileage-header col-12 radius-top pb-3 px-2'
              data-selected={this.state.supplierId}
            >
              <div className='mileage-header-infos'>
                <div className='row mt-md-0 mt-2 align-items-start align-items-md-center h-100'>
                  <div className='col mr-auto'>
                    <h2 className='txt-uppercase txt-font-body txt-body-sm'>
                      Milhas Aéreas
                    </h2>
                    <h3 className='mt-1 txt-circular-book txt-title-2 d-none d-md-block'>
                      Converta seus{' '}
                      {this.props.currencyConfiguration.pointsName} em viagens
                      completas.
                    </h3>
                  </div>
                  <div className='col-auto'>
                    <img src={this.state.imageBanner} />
                  </div>
                  <div className='col-12 d-block d-md-none'>
                    <h3 className='mt-1 txt-circular-book txt-title'>
                      Converta seus{' '}
                      {this.props.currencyConfiguration.pointsName}
                      <br />
                      em viagens completas.
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className='mileage-body col-12 pb-2'>
              <div className='row mx-1 py-2 px-1 radius-top bg-white'>
                <Select
                  id='SelectPartners'
                  label='Transferir para'
                  className='col-12 col-md-3 mb-1 form-field mileage-form-tablets'
                  hasEmpty
                  displayValue='name'
                  selectedValue='vendorId'
                  image='logoUrl'
                  classImage='r-0'
                  options={this.props.partners || []}
                  imageAlign='image-right'
                  required
                  onChange={this.selectPartnersOnChange}
                />

                <div className='col-12 col-md-5 form-field form-field-lg mileage-form-tablets mb-1 mb-md-0'>
                  <div className='row align-items-center h-100'>
                    <Input
                      id='FidelityNumber'
                      name='FidelityNumber'
                      className='col-12 col-md-6 form-field mb-1 mb-md-0'
                      label={this.state.fidelityLabel || 'CPF ou Loyalty Number'}
                      value={this.state.loyaltyNumber}
                      onChange={this.inputOnlyNumbers}
                      maxLength='11'
                      disabled={this.state.disabledField}
                    />
                    <Input
                      id='InputPoints'
                      name='InputPoints'
                      className='col-12 col-md-6 form-field mb-1 mb-md-0'
                      label={`Transferir quantos ${this.props.currencyConfiguration.pointsName}?`}
                      required
                      value={this.state.points}
                      onBlur={this.inputPointsOnblur}
                      onChange={this.inputPointsOnChange}
                      maxLength='7'
                      disabled={this.state.disabledField}
                    />
                    <Checkbox
                      style={{ position: 'relative', marginLeft: '20px' }}
                      id='CheckboxAllPoints'
                      checked={this.state.convertAllPoints}
                      className='form-field checkbox-field col-5 ml-auto my-0 nowrap r-3 d-none d-md-block'
                      labelClass='l-0'
                      label={`Transferir todos os meus ${this.props.currencyConfiguration.pointsName}`}
                      onChange={this.checkboxAllPointsChange}
                      disabled={this.state.disabledField}
                    />
                  </div>
                </div>
                <Loading ready={!this.props.isLoading}>
                  <div className='col-12 col-md-auto mb-md-0 mileage-form-tablets hidden-icon form-field mt-1 mt-md-0'>
                    <div className='row align-items-center'>
                      <div className='col'>
                        <Icon
                          iconName='icon_return'
                          className='color-brand-1 icon-sm d-none d-md-block py-2'
                        />
                      </div>
                    </div>
                  </div>
                </Loading>
                <Input
                  id='MileageWillGet'
                  name='MileageWillGet'
                  className='col-12 col-md mb-md-0 mileage-form-tablets hidden-icon form-field'
                  label='Você vai receber no programa parceiro'
                  required
                  value={this.handleFormatValue(
                    this.props.calculator.miles || 0
                  )}
                  disabled
                />
                <div className='col-12 col-md-auto d-none d-md-block'>
                  <Button
                    id={'DoneMileage'}
                    name={'DoneMileage'}
                    className='btn-featured btn-icon btn-icon-only'
                    iconName='icon_send txt-body-lg'
                    onClick={this.redeem}
                    disabled={!readyForRedemption}
                  />
                </div>

                <div className='checkbox-field col-12 col-md-3 mb-md-0 mb-1 mt-0 accept-terms r-5 mr-md-1 px-0'>
                  <div className='row'>
                    <Checkbox
                      id='CheckboxAllPointsMobile'
                      checked={this.state.convertAllPoints}
                      className='checkbox-field col-12 nowrap d-block d-md-none px-0'
                      labelClass='l-0'
                      label={`Transferir todos os meus ${this.props.currencyConfiguration.pointsName}`}
                      onChange={this.checkboxAllPointsChange}
                      disabled={this.state.disabledField}
                    />
                    <Checkbox
                      id='aceito_termos'
                      className='col-1 px-0'
                      labelClass='l-0'
                      onChange={this.checkboxRegulationChange}
                      checked={this.state.acceptTerms}
                      disabled={this.state.disabledField}
                    />
                    <div className='col px-0 align-self-center d-none d-md-block'>
                      <p className='txt-body-sm'>
                        Li e aceito os{' '}
                        <a
                          href='javascript:void(0)'
                          className='txt-body-sm color-brand-2 txt-underline'
                          role='button'
                          onClick={this.showTerms}
                        >
                          termos do regulamento
                        </a>
                      </p>
                    </div>
                    <div className='col px-0 align-self-center d-block d-md-none'>
                      <p className='txt-body-sm'>
                        Li e aceito os{' '}
                        <a
                          href='javascript:void(0)'
                          className='txt-body-sm color-brand-2 txt-underline'
                          role='button'
                          onClick={e => this.setState({ showModal: true })}
                        >
                          termos do regulamento
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className='col-12 col-md-auto d-block d-md-none'>
                  <Button
                    id={'DoneMileageSmall'}
                    name={'DoneMileageSmall'}
                    className='btn-featured btn btn-sm'
                    text='Transferir Agora'
                    onClick={this.redeem}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <ModalServices
            title={'Termos do Regulamento de Milhas'}
            show={this.state.showModal}
            onClose={e => this.setState({ showModal: false })}
            acceptTerms={e => {
              this.setState({
                showModal: false
              })
              this.acceptTerms(true)
            }}
            terms={{
              vendorId: this.state.supplierId,
              type: REGULATION_TYPE_VENDOR
            }}
          />
        </div>
      </div>
    )
  }
}

// Objeto que retorna da ação: loadMileagePartners.
const partnerMessage = PropTypes.shape({
  name: PropTypes.string.isRequired,
  supplierId: PropTypes.number.isRequired
})

// Objeto que retorna da ação: convertPointsToMiles.
const calculatorMessage = PropTypes.shape({
  points: PropTypes.string,
  miles: PropTypes.string
})

// Propriedades do componente Mileage.
Mileage.propTypes = {
  partners: PropTypes.arrayOf(partnerMessage).isRequired,
  calculator: PropTypes.arrayOf(calculatorMessage),
  isLoading: PropTypes.bool.isRequired,
  getPartners: PropTypes.func.isRequired,
  pointsToMiles: PropTypes.func.isRequired,
  clearCalculator: PropTypes.func,
  partBalance: PropTypes.number,
  mileageRedemption: PropTypes.func.isRequired,
  participant: PropTypes.object,
  errorRedemption: PropTypes.string,
  currencyConfiguration: PropTypes.object,
  closeError: PropTypes.func
}

const mapStateToProps = ({ mileage, balance, participant, catalog }) => ({
  partners: mileage.partners,
  firstPartner: mileage.firstPartner,
  calculator: mileage.calculator,
  isLoading: mileage.isLoading,
  getPartners: mileage.getPartners,
  pointsToMiles: mileage.pointsToMiles,
  partBalance: balance.pointsValue,
  participant: participant,
  errorRedemption: mileage.errorRedemption,
  currencyConfiguration: catalog.currencyConfiguration
})

const mapDispatchToProps = dispatch => ({
  clearCalculator: () => dispatch(actions.clearCalculator()),
  getPartners: () => dispatch(actions.getPartners()),
  pointsToMiles: (supplierId, points) =>
    dispatch(actions.convertPointsToMiles(supplierId, points)),
  mileageRedemption: (order, supplierId) =>
    dispatch(actions.mileageRedemption(order, supplierId)),
  closeError: () => dispatch(actions.closeErrorMileage())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Mileage)



// WEBPACK FOOTER //
// ./src/features/Services/Mileage/Mileage.js